/**
 * Klasa statyczna z generująca URLe na podstawie obiektu ProductSearchRequest oraz ewentualnych dodatkowych parametrów
 */
export class ProductSearchUrlBuilder {
    static buildUrl(url, params = null, request = null) {
        // Kopiujemy URLa, żeby nie modyfikować oryginału
        const newUrl = new URL(url.toString());
        // dodajemy do URLa parametry z tablicy params
        if (typeof params === 'object' && params !== null) {
            for (const key in params) {
                if (Object.prototype.hasOwnProperty.call(params, key)) {
                    newUrl.searchParams.set(key, params[key]);
                }
            }
        }
        if (request && request.availableInPos !== null) {
            newUrl.searchParams.set('is', '1');
        }
        if (request && request.pos !== null) {
            newUrl.searchParams.set('shop', request.pos.id.toString());
        }
        return newUrl;
    }
}
